export default "__VITE_ASSET__MUmOUR$q__"